module.exports = __webpack_public_path__ + "img/圆四排.4be340bd.png";